import { render, staticRenderFns } from "./DatesRanges.vue?vue&type=template&id=28a0cf56&"
import script from "./DatesRanges.vue?vue&type=script&lang=ts&"
export * from "./DatesRanges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports